import { Directive, ElementRef, AfterViewInit, forwardRef, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator, NgControl } from '@angular/forms';

@Directive({
    selector: '[sgtFone]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => FoneDirective), multi: true }
    ]
})
export class FoneDirective implements AfterViewInit, OnChanges, Validator {
    element: any;
    @Input() mask: string;
    @Output() ngModelChange = new EventEmitter<string>()
    @Input() ngControl: NgControl;
    @Input() isValidate = true; // Se deve validar o fone
    @Input() isApplyMask = true; // Se deve aplicar a máscara do fone

    constructor(private el: ElementRef) {
        this.element = jQuery(this.el.nativeElement) as any;

        /** Ao colar algum valor no input, formatamos ele */
        this.element.on('paste', (e) => {
            if (this.isApplyMask) {
                // Obtendo o valor colado
                let value = (e.originalEvent || e).clipboardData.getData('text/plain') as string;
                value = this.clearFormat(value);

                // Se o tamanho da string colada for menor que 13 caracteres, então setamos o maxlength do input com o tamanho da string,
                // pois se não, a mask completava o restante do valor até preencher o maxlength
                if (value.trim().length < 13) {
                    this.element.attr('maxlength', value.trim().length);
                }

                // Formatando e alterando o model com o valor formatado
                value = this.element.masked(value) as string;
                this.ngModelChange.emit(value);
            }
        });

    }

    ngAfterViewInit() {
        if (this.isApplyMask) {
            this.applyMask();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isValidate') {
                if (!changes[propName].isFirstChange()) {
                    this.ngControl.control.updateValueAndValidity();
                }
            }  else if (propName === 'isApplyMask') {
                if (this.isApplyMask) {
                    this.applyMask();
                } else {
                    this.removeMask();
                }
            }
        }
    }

    /** Aplica a máscara no elemento */
    private applyMask() {
        const self = this;
        const maskBehavior = function(val) {
            if (self.mask) {
                return self.mask;
            }
            return val.replace(/\D/g, '').length === 11 ? '00-00000-0000' : '00-00000-0009';
        }

        const maskOptions = {
            onKeyPress(val, e, field, options) {
                self.element.attr('maxlength', 13);
                field.mask(maskBehavior.apply({}, arguments), options);
            },
            placeholder: '__-_____-____'
        };

        this.element.mask(maskBehavior, maskOptions);
    }

    /** Remove a máscara aplicada no elemento */
    private removeMask() {
        this.element.unmask();
        this.element.removeAttr('placeholder');
        this.element.removeAttr('maxlength');
    }

    /** Limpa os caracteres especiais da mascara do fone */
    private clearFormat(value: string): string {
        value =  value.replace(/[\(\)\.\s-]+/g, '');
        return value.trim();
    }

    /** Validando o número do telefone informado */
    private validar(fone: string): boolean {
        if (!fone) {
            return true;
        }

        const foneSemFormatacao = this.clearFormat(fone);
        return foneSemFormatacao.trim().length >= 10;
    }

    /** Realiza a validação do FormControl de telefones */
    validate(c: FormControl) {
        // Se estiver configurado para não validar, então não retornamos nenhum erro
        if (!this.isValidate) {
            return null;
        }

        if (!c.value) {
            return null;
        }
        const isValid = this.validar(c.value);
        if (!isValid) {
            return {
                foneInvalido: {
                    valid: false
                }
            }
        }
        return null;
    }
}
